export default "__VITE_ASSET__CvgJf6vc__"